import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core'
import { initializeApp, provideFirebaseApp } from '@angular/fire/app'
import { provideAnimations } from '@angular/platform-browser/animations'
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router'

import { provideCharts, withDefaultRegisterables } from 'ng2-charts'
import { provideMarkdown } from 'ngx-markdown'

import { provideIconsInitializer } from '@yoshu-lib/core/config/register-icons.factory'
import { provideTranslate } from '@yoshu-lib/core/config/translate.provider'

import { ENTITY_DETAIL_SHOW_LIST_BREADCRUMB } from '@yoshu-lib/features/admin/pages/entities/entity-detail/entity-detail.token'

import { environment } from '@treves/env/environment'

import { routes } from './app.routes'
import { provideMarkdownCustomRenderer } from './core/config/marked-options.provider'
import { provideCore } from './core/core.providers'
import { provideTrevesHttp } from './core/http/http.provider'

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),

    ...provideCore(),

    provideTrevesHttp(),
    provideAnimations(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideMarkdown(),
    provideMarkdownCustomRenderer(),
    provideTranslate(),
    provideIconsInitializer(),
    provideCharts(withDefaultRegisterables()),

    { provide: ENTITY_DETAIL_SHOW_LIST_BREADCRUMB, useValue: true }
  ]
}
